import Home from "./pages/Home"
import 'bootstrap/dist/css/bootstrap.min.css';

//? Component
function App() {
  //? JS kodu


  return (
    //! JSX (HTML- JS'nin birleşmiş hali)
    <Home/>
  )
}

export default App
